/* tslint:disable */
/* eslint-disable */
/**
 * Example API
 * API description
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateItineraryRequest
 */
export interface CreateItineraryRequest {
    /**
     * Title of the itinerary
     * @type {string}
     * @memberof CreateItineraryRequest
     */
    title: string;
    /**
     * Short description of the itinerary
     * @type {string}
     * @memberof CreateItineraryRequest
     */
    shortDescription?: string | null;
    /**
     * URL of the itinerary image
     * @type {string}
     * @memberof CreateItineraryRequest
     */
    imageUrl?: string | null;
    /**
     * Key highlights of the itinerary
     * @type {string}
     * @memberof CreateItineraryRequest
     */
    highlights?: string | null;
    /**
     * Detailed description of the itinerary
     * @type {string}
     * @memberof CreateItineraryRequest
     */
    description?: string | null;
    /**
     * Array of country IDs where this itinerary takes place
     * @type {Array<string>}
     * @memberof CreateItineraryRequest
     */
    countryIds?: Array<string> | null;
    /**
     * ID of the profile creating the itinerary
     * @type {string}
     * @memberof CreateItineraryRequest
     */
    accountId: string;
}

/**
 * Check if a given object implements the CreateItineraryRequest interface.
 */
export function instanceOfCreateItineraryRequest(value: object): value is CreateItineraryRequest {
    if (!('title' in value) || value['title'] === undefined) return false;
    if (!('accountId' in value) || value['accountId'] === undefined) return false;
    return true;
}

export function CreateItineraryRequestFromJSON(json: any): CreateItineraryRequest {
    return CreateItineraryRequestFromJSONTyped(json, false);
}

export function CreateItineraryRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateItineraryRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'title': json['title'],
        'shortDescription': json['shortDescription'] == null ? undefined : json['shortDescription'],
        'imageUrl': json['imageUrl'] == null ? undefined : json['imageUrl'],
        'highlights': json['highlights'] == null ? undefined : json['highlights'],
        'description': json['description'] == null ? undefined : json['description'],
        'countryIds': json['countryIds'] == null ? undefined : json['countryIds'],
        'accountId': json['accountId'],
    };
}

  export function CreateItineraryRequestToJSON(json: any): CreateItineraryRequest {
      return CreateItineraryRequestToJSONTyped(json, false);
  }

  export function CreateItineraryRequestToJSONTyped(value?: CreateItineraryRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'title': value['title'],
        'shortDescription': value['shortDescription'],
        'imageUrl': value['imageUrl'],
        'highlights': value['highlights'],
        'description': value['description'],
        'countryIds': value['countryIds'],
        'accountId': value['accountId'],
    };
}

